var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"center-on-page"},[_vm._t("default"),_c('div',{staticClass:"icon",class:_vm.size},[_c('i',{staticClass:"fa fa-spinner fa-spin fa-fw",class:_vm.fa})])],2)}
var staticRenderFns = []

export { render, staticRenderFns }